import { initTabletOpenPortrait } from "./init-tablet-open-portrait";
import { initTabletOpenLandscape } from "./init-tablet-open-landscape";
import { initTabletClosePortrait } from "./init-tablet-close-portrait";
import { initTabletCloseLandscape } from "./init-tablet-close-landscape";
import { initTabletValue } from "./init-tablet-value";
import { ORIENTATION_KEY_TABLET, STORAGE_KEY } from "../shared/constant";
import { Orientation, SidebarState, TabletSelectors } from "../types/index-type";


const ensureSidebarStatus = (): SidebarState => {
  const status = localStorage.getItem(STORAGE_KEY);

  if (status === "open" || status === "close") {
    return status;
  }

  localStorage.setItem(STORAGE_KEY, "open");
  return "open";
};

const readOrientation = (): Orientation | null => {
  const value = localStorage.getItem(ORIENTATION_KEY_TABLET);

  if (value === "portrait" || value === "landscape") {
    return value;
  }

  return null;
};

const detectOrientation = (): Orientation => {
  const orientation: Orientation =
    window.innerWidth > window.innerHeight ? "landscape" : "portrait";

  localStorage.setItem(ORIENTATION_KEY_TABLET, orientation);
  return orientation;
};

export const initStateTablet = (): TabletSelectors | undefined => {
  let domElement: TabletSelectors | undefined;

  const {
    sidebarColumnsPortrait,
    mainColumnsPortrait,
    wholeLeftPositionOpen,
    wholeLeftPositionCloseLandscape,
    wholeLeftPositionClosePortrait,
    sidebarColumnsLandscape,
    mainColumnsLandscape,
    mainColumnsFillwidth,
  } = initTabletValue();

  window.addEventListener("load", () => {
    detectOrientation();
    document.body?.classList.add("loaded");
  });

  const sideStatus = ensureSidebarStatus();
  const angle = readOrientation();

  if (!angle) {
    return undefined;
  }

  if (sideStatus === "open" && angle === "landscape") {
    domElement = initTabletOpenLandscape({
      wholeLeftPositionOpen,
      sidebarColumnsLandscape,
      mainColumnsLandscape,
    });
  } else if (sideStatus === "open" && angle === "portrait") {
    domElement = initTabletOpenPortrait({
      wholeLeftPositionOpen,
      sidebarColumnsPortrait,
      mainColumnsPortrait,
    });
  } else if (sideStatus === "close" && angle === "landscape") {
    domElement = initTabletCloseLandscape({
      wholeLeftPositionCloseLandscape,
      sidebarColumnsLandscape,
      mainColumnsFillwidth,
    });
  } else if (sideStatus === "close" && angle === "portrait") {
    domElement = initTabletClosePortrait({
      wholeLeftPositionClosePortrait,
      sidebarColumnsPortrait,
      mainColumnsFillwidth,
    });
  }

  return domElement;
};
